var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "工號",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "empNo"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入工號" },
                            model: {
                              value: _vm.model.empNo,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "empNo", $$v)
                              },
                              expression: "model.empNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "站點code",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "webSiteCode"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入站點code" },
                            model: {
                              value: _vm.model.webSiteCode,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "webSiteCode", $$v)
                              },
                              expression: "model.webSiteCode"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "站點url",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "webSiteUrl"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入站點url" },
                            model: {
                              value: _vm.model.webSiteUrl,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "webSiteUrl", $$v)
                              },
                              expression: "model.webSiteUrl"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "資料來源",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "fromSource"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入資料來源" },
                            model: {
                              value: _vm.model.fromSource,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "fromSource", $$v)
                              },
                              expression: "model.fromSource"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "刪除标示",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "delFlag"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入刪除标示" },
                            model: {
                              value: _vm.model.delFlag,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "delFlag", $$v)
                              },
                              expression: "model.delFlag"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "备注",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "remark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入备注" },
                            model: {
                              value: _vm.model.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "remark", $$v)
                              },
                              expression: "model.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "進入歷史表時間",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "historyTime"
                          }
                        },
                        [
                          _c("j-date", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: "请选择進入歷史表時間",
                              "date-format": "YYYY-MM-DD HH:mm:ss"
                            },
                            model: {
                              value: _vm.model.historyTime,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "historyTime", $$v)
                              },
                              expression: "model.historyTime"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: "進入歷史表備註",
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "historyRemark"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "请输入進入歷史表備註" },
                            model: {
                              value: _vm.model.historyRemark,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "historyRemark", $$v)
                              },
                              expression: "model.historyRemark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }